export interface Card {
    type: CardType
}

export enum CardType {
    CourseCard = "CourseCard",
    ParticipantCard = "ParticipantCard",
    GroupCard = "GroupCard",
    TeamCard = "TeamCard"
}

export interface ScorecardRow<Value, Total> {
    outValues: Value[],
    inValues: Value[] | null,
    outTotal: Total | null,
    inTotal: Total | null,
    total: Total
}